var WarmupQuestions = require("lib/academic/WarmupQuestions");

class FictionVocabularyQuestion extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}

	isConnotative() {
		return this.props.answers[FictionVocabularyQuestion.STEM][NONLITERAL_WORD_TYPE].includes("connotative");
	}

	getDisplayStatus() {
		var answers = this.props.answers[FictionVocabularyQuestion.STEM];
		if (answers == undefined || _.isEmpty(answers)) {
			return [HARD_WORD_STAGE];
		}

		if (!answers[HARD_WORD]) {
			return [HARD_WORD_STAGE];
		}

		if (this.props.level == "1") {
			if (!answers[SENSORY_WORD]) {
				return [SPECIAL_WORD_STAGE];
			} else {
				return [SPECIAL_WORD_STAGE, true];
			}
		}

		if (!answers[NONLITERAL_WORD]) {
			return [SPECIAL_WORD_STAGE];
		}

		if (this.props.level == "2") {
			if (!answers[NONLITERAL_WORD_TYPE]) {
				return [SPECIAL_TYPE_STAGE];
			} else {
				return [SPECIAL_TYPE_STAGE, true];
			}
		}

		if (!answers[NONLITERAL_WORD_TYPE]) {
			return [SPECIAL_WORD_STAGE];
		}

		if (!answers[LITERAL_MEANING]) {
			return [MEANING_LITERAL_STAGE];
		}

		if (!answers[NONLITERAL_MEANING]) {
			return [MEANING_NONLITERAL_STAGE];
		} else {
			return [MEANING_NONLITERAL_STAGE, true];
		}
	}

	render() {
		var displayStatus = this.getDisplayStatus();
		var stage = displayStatus[0];
		var displayButton = displayStatus[1];
		if (displayButton) {
			var finishButtonDisplay = this.props.renderFinishButtonF();
		}

		var hardWordDisplay = (
			<div>
				{ this.props.getTextF("label1", HARD_WORD_STAGE) }
				{ this.props.renderInputF(HARD_WORD) }
			</div>
		);

		if (_.indexOf(STAGES, stage) > 0) {
			if (this.props.level == "3") {
				var additionalSpecWordDisplay = (
					<span>
						{ this.props.renderDropdownF("choices1", SPECIAL_WORD_STAGE, NONLITERAL_WORD_TYPE, [HARD_WORD, NONLITERAL_WORD]) }
						{ this.props.getTextF("label2", SPECIAL_WORD_STAGE) }
					</span>
				);
			}

			var answerKey = this.props.level == "1" ? SENSORY_WORD : NONLITERAL_WORD;
			var specialWordDisplay = (
				<div>
					{ this.props.getTextF("label1", SPECIAL_WORD_STAGE) }
					{ additionalSpecWordDisplay }
					{ this.props.renderInputF(answerKey) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 1 && this.props.level == "2") {
			var specialWord = this.props.answers[FictionVocabularyQuestion.STEM][NONLITERAL_WORD];
			var replacementsHash = {};
			replacementsHash[WarmupQuestions.ENTERED_WORD] = specialWord;

			var specialTypeDisplay = (
				<div>
					{ this.props.getTextF("label1", SPECIAL_TYPE_STAGE, replacementsHash) }
					{ this.props.renderDropdownF("choices1", SPECIAL_TYPE_STAGE, NONLITERAL_WORD_TYPE, [HARD_WORD, NONLITERAL_WORD]) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 2) {
			var specialWord = this.props.answers[FictionVocabularyQuestion.STEM][NONLITERAL_WORD];
			var replacementsHash = {};
			replacementsHash[WarmupQuestions.ENTERED_WORD] = specialWord;

			var label = this.isConnotative() ? "label1" : "label2";
			var literalMeaningDisplay = (
				<div>
					{ this.props.getTextF(label, MEANING_LITERAL_STAGE, replacementsHash) }
					{ this.props.renderInputF(LITERAL_MEANING) }
				</div>
			);
		}

		if (_.indexOf(STAGES, stage) > 3) {
			var label = this.isConnotative() ? "label1" : "label2";
			var nonliteralMeaningDisplay = (
				<div>
					{ this.props.getTextF(label, MEANING_NONLITERAL_STAGE, replacementsHash) }
					{ this.props.renderInputF(NONLITERAL_MEANING) }
				</div>
			);
		}

		return (
			<div>
				{ hardWordDisplay }
				{ specialWordDisplay }
				{ specialTypeDisplay }
				{ literalMeaningDisplay }
				{ nonliteralMeaningDisplay }
				{ finishButtonDisplay }
			</div>
		);
	}
}

FictionVocabularyQuestion.STEM = "fvocab";

// stages
var HARD_WORD_STAGE = "hardword";
var SPECIAL_WORD_STAGE = "specialword";
var SPECIAL_TYPE_STAGE = "specialtype";
var MEANING_LITERAL_STAGE = "meaningliteral";
var MEANING_NONLITERAL_STAGE = "meaningnonliteral";

var STAGES = [
	HARD_WORD_STAGE, SPECIAL_WORD_STAGE, SPECIAL_TYPE_STAGE, MEANING_LITERAL_STAGE,
	MEANING_NONLITERAL_STAGE
];

// answer keys
var HARD_WORD = "hard_word";
var SENSORY_WORD = "sensory_word";
var NONLITERAL_WORD = "nonliteral_word";
var NONLITERAL_WORD_TYPE = "nonliteral_word_type";
var LITERAL_MEANING = "literal_meaning";
var NONLITERAL_MEANING = "nonliteral_meaning";

FictionVocabularyQuestion.propTypes = PageStrictPropTypes({
	level: PropTypes.string.isRequired,
	answers: PropTypes.object.isRequired,
	getTextF: PropTypes.func.isRequired,
	renderDropdownF: PropTypes.func.isRequired,
	renderInputF: PropTypes.func.isRequired,
	renderFinishButtonF: PropTypes.func.isRequired,
});

module.exports = FictionVocabularyQuestion;


// WEBPACK FOOTER //
// ./modules/components/writing/quizzes/warmups/FictionVocabularyQuestion.js